import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import LoadingSpinner from "../../Loading/component";
import CategoryEditComponent from "./component";

const CategoryEditContainer = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const categoryData = location.state?.categoryData;
  
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image: null,
  });
  const [imagePreview, setImagePreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (categoryData) {
      setFormData({
        name: categoryData.name || '',
        description: categoryData.description || '',
        image: null,
      });
      setImagePreview(categoryData.image_url || '');
      setInitialLoading(false);
    } else if (id) {
      fetchCategoryDetails();
    } else {
      toastr.error("Error", "No category data found");
      navigate('/home/product/categories');
    }
  }, [categoryData, id, navigate]);

  const fetchCategoryDetails = () => {
    setInitialLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/product-categories/${id}`,
      "GET",
      undefined,
      (response) => {
        if (response) {
          setFormData({
            name: response.name || '',
            description: response.description || '',
            image: null,
          });
          setImagePreview(response.image_url || '');
        }
        setInitialLoading(false);
      },
      (err) => {
        console.log("Error fetching category:", err);
        toastr.error("Failed", "Unable to fetch category details");
        setInitialLoading(false);
        navigate('/home/product/categories');
      }
    );
  };

  // Check if form is valid
  const isFormValid = formData.name.trim() !== '';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (file) => {
    if (file) {
      if (!file.type.match('image.*')) {
        toastr.error("Error", "Please upload an image file");
        return;
      }
      
      if (file.size > 5 * 1024 * 1024) {
        toastr.error("Error", "Image size should be less than 5MB");
        return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData(prev => ({ ...prev, image: file }));
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreview('');
      setFormData(prev => ({ ...prev, image: null }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      setLoading(true);
      
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      if (formData.description) {
        formDataToSend.append('description', formData.description);
      }
      if (formData.image) {
        formDataToSend.append('image', formData.image);
      }
      
      const categoryId = id || categoryData?.id;
      
      props.getDataFromAPI(
        `/partner/api/v1/product-categories/${id}`,
        'PUT',
        formDataToSend,
        (response) => {
          toastr.success("Success", "Category updated successfully!");
          setLoading(false);
          navigate('/home/product/categories');
        },
        (err) => {
          console.log("Error updating category:", err);
          toastr.error("Failed", err?.message || "Unable to update category");
          setLoading(false);
        },
        {
          'Content-Type': 'multipart/form-data'
        }
      );
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (initialLoading) {
    return (
      <div className="category-create-container">
        <Sidebar />
        <div className="full-page-loader">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <CategoryEditComponent
      formData={formData}
      imagePreview={imagePreview}
      loading={loading}
      isFormValid={isFormValid}
      onChange={handleChange}
      onImageChange={handleImageChange}
      onSubmit={handleSubmit}
      onBack={handleBack}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(CategoryEditContainer);